<template>
  <div>
    <v-form v-model="valid" ref="form" lazy-validation @submit="reset">
      <v-container class="pt-0">
        <span class="headline">Passwort neu setzen</span>
        <v-row v-if="successMessage">
          <v-col cols="12">
            <alert v-if="successMessage" :text="successMessage" :type="'success'"></alert>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              data-test-id="email"
              v-model="email"
              :disabled="true"
              :rules="emailRules"
              name="email"
              autocomplete="username"
              :label="$t('common.email-address')"
              prepend-icon="mdi-at"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              data-test-id="password"
              v-model="password"
              :disabled="loading"
              :clearable="true"
              id="password"
              :label="$t('common.password')"
              autocomplete="new-password"
              :rules="passwordRules"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              data-test-id="confirmPassword"
              v-model="confirmPassword"
              :clearable="true"
              :disabled="loading"
              :label="$t('common.confirm-password')"
              autocomplete="new-password"
              :rules="passwordRules"
              name="confirmPassword"
              prepend-icon="mdi-lock"
              type="password"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              type="submit"
              color="primary"
              class="mr-4"
              :disabled="!valid || loading || !filled"
              :loading="loading"
            >
              <v-icon left>mdi-content-save</v-icon>Passwort speichern
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="mr-4" :disabled="loading" link :to="'/login' + ($route.query.redirect ? '?redirect=' + encodeURIComponent($route.query.redirect) : '')">
              <v-icon left>mdi-login</v-icon>Zurück zum Login
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import {MUTATION_CHANGE_EMAIL} from "@/plugins/store.js";
import Alert from "@/widgets/Alert";

export default {
  name: "ResetPassword",
  components: {
    Alert,
  },
  data: () => ({
    valid: false,
    loading: false,
    successMessage: undefined,
    email: "",
    password: undefined,
    confirmPassword: undefined,
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    passwordRules: [
      v => !!v || "Das Passwort wird benötigt",
      v =>
        (v && v.length >= 8) ||
        "Das Passwort muss mindestens 8 Zeichen lang sein"
    ],
    error: undefined
  }),
  props: {
    token: {
      type: String,
      required: true,
    }
  },

  mounted() {
    this.email = this.$route.query.email;
  },

  beforeDestroy() {},

  computed: {
    filled() {
      return this.email && this.email.length > 0 && this.password && this.password.length > 0 && this.confirmPassword && this.confirmPassword.length > 0;
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset(e) {
      e.preventDefault();
      this.loading = true;
      this.successMessage = undefined;
      console.log("Reseting password...");
      this.$api.resetPassword(this.email, this.token, this.password, this.confirmPassword)
        .then(response => {
          this.loading = false;
          console.log(response);
          this.resetForm();
          this.successMessage = "Passwort erfolgreich neu gesetzt.";
          // We may login directly now
          this.$store.commit(MUTATION_CHANGE_EMAIL, this.email);
          this.$router.push("/login");
        })
        .catch(error => {
          // also catches the store authorized error
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    resetForm() {
      this.error = undefined;
      this.$refs.form.reset();
    }
  }
};
</script>
